import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.flash()
    } catch (e) {
      this.sourceTarget.type = "text"
      this.sourceTarget.select()
      document.execCommand("copy")
      this.sourceTarget.type = "hidden"
      this.flash()
    }
  }

  flash() {
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = "Copied"
    this.buttonTarget.disabled = true
    setTimeout(() => {
      this.buttonTarget.textContent = original
      this.buttonTarget.disabled = false
    }, 2000)
  }
}
